// extracted by mini-css-extract-plugin
export default {"groupChart":"styles_groupChart__wiFD7"};